import { getCompatEnv } from '@fabric-app/compat/capabilities/environment';
import { UploadErrorCode } from '@fabric-app/types/upload';

const ERROR_RETRYABLE_MAP = {
  [UploadErrorCode.FileTooLarge]: false,
  [UploadErrorCode.FileUploadFailed]: true,
  [UploadErrorCode.FileUploadCancelled]: false,
  [UploadErrorCode.FileTreeTooDeep]: false,
  [UploadErrorCode.QuotaExceeded]: false,
  [UploadErrorCode.UploadTaskMissing]: false,
  [UploadErrorCode.FileNotAvailable]: false,
  [UploadErrorCode.Unknown]: true,
  [UploadErrorCode.TaskMissingResult]: true,
  [UploadErrorCode.ChunkMissingLink]: false,
  [UploadErrorCode.Timeout]: true,
  [UploadErrorCode.UploadChunkMissing]: false
};
const ERROR_DEFAULT_MESSAGE_MAP = {
  [UploadErrorCode.FileTooLarge]: "This file is too big!",
  [UploadErrorCode.FileUploadFailed]: "Upload failed.",
  [UploadErrorCode.FileUploadCancelled]: "Upload cancelled.",
  [UploadErrorCode.FileTreeTooDeep]: "File tree is too deep.",
  [UploadErrorCode.QuotaExceeded]: "You have exceeded your storage limit.",
  [UploadErrorCode.UploadTaskMissing]: "Upload task missing.",
  [UploadErrorCode.FileNotAvailable]: "File not available.",
  [UploadErrorCode.Unknown]: "Something went wrong. Please try again.",
  [UploadErrorCode.TaskMissingResult]: "Task missing result.",
  [UploadErrorCode.ChunkMissingLink]: "Chunk missing link.",
  [UploadErrorCode.UploadChunkMissing]: "Upload chunk missing.",
  [UploadErrorCode.Timeout]: "Upload failed."
};
const ERROR_USER_FACING_MAP = {
  [UploadErrorCode.FileTooLarge]: true,
  [UploadErrorCode.FileUploadFailed]: true,
  [UploadErrorCode.FileUploadCancelled]: true,
  [UploadErrorCode.FileTreeTooDeep]: true,
  [UploadErrorCode.QuotaExceeded]: true,
  [UploadErrorCode.UploadTaskMissing]: false,
  [UploadErrorCode.FileNotAvailable]: false,
  [UploadErrorCode.Unknown]: true,
  [UploadErrorCode.TaskMissingResult]: true,
  [UploadErrorCode.ChunkMissingLink]: true,
  [UploadErrorCode.UploadChunkMissing]: false,
  [UploadErrorCode.Timeout]: true
};
class UploadError extends Error {
  constructor(code, message = ERROR_DEFAULT_MESSAGE_MAP[code], retryable = ERROR_RETRYABLE_MAP[code], userFacing = ERROR_USER_FACING_MAP[code]) {
    super(message);
    this.code = code;
    this._message = message;
    this.retryable = retryable;
    this.userFacing = userFacing;
  }
  get message() {
    const isDev = getCompatEnv().isFabricDev;
    return this.userFacing || isDev ? this._message : ERROR_DEFAULT_MESSAGE_MAP[UploadErrorCode.Unknown];
  }
  set message(message) {
    this._message = message;
  }
}

export { UploadError };
//# sourceMappingURL=upload.error.js.map
